import { render } from "./PatchRequestList.vue?vue&type=template&id=5ecc81d4"
import script from "./PatchRequestList.vue?vue&type=script&lang=js"
export * from "./PatchRequestList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__